import { useEffect } from 'react';
import { Outlet } from 'react-router';
import { Box, Container, useMediaQuery } from '@mui/material';

import { MainLayoutLoader } from '~/application/layout/MainLayoutLoader';
import { useAppDispatch } from '~/application/hooks';
import { setDrawerOpen } from '~/application/slice';
import { MainDrawer } from './drawer/MainDrawer';
import { MainHeader } from './header/MainHeader';
import { PageHeader } from './page/PageHeader';

export const MainLayout = () => {
    const dispatch = useAppDispatch();
    const downXL = useMediaQuery(theme => theme.breakpoints.down('xl'));

    useEffect(() => {
        dispatch(setDrawerOpen(!downXL));
    }, [downXL]);

    return (
        <Box sx={{ display: 'flex', width: '100%' }}>
            <MainHeader />
            <MainDrawer />

            <Box component="main" sx={{ width: `calc(100% - 260px)`, flexGrow: 1, p: { xs: 2, sm: 3 }, mt: 7.5 }}>
                <Container
                    maxWidth={false}
                    sx={{ position: 'relative', minHeight: 'calc(100vh - 110px)', display: 'flex', flexDirection: 'column' }}
                >
                    <PageHeader />
                    <Outlet />
                </Container>
            </Box>

            <MainLayoutLoader />
        </Box>
    );
};
